import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import PaginationFiltration from "./components/pagination-filtration";
import Arrow from "./components/Arrow";
import searchTable, { sortTable } from "./utils";
import useSubmissionsAPI from "../../../hooks/useGetSubmissionsAPI"; // Adjust the import path if needed
import { useSelector } from "react-redux";

const SubmissionLists = () => {
  const { auth } = useSelector((state) => state.auth);
  const [submissions, setSubmissions] = useState([]);
  const navigate = useNavigate();
  const {id} = useParams(); // Replace with dynamic quest ID if needed
  const { isLoading, data } = useSubmissionsAPI(id);
  const [fullData, setFullData] = useState([]);
  const [sortedBy, setSortedBy] = useState("");
  const [sortStatus, setSortStatus] = useState("");
  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get("search");
  const isAdmin =
    auth.user.role === "admin";
  if(!isAdmin){
    navigate(`/quest-view/${id}`)
  }
  useEffect(() => {
    if (!isLoading) {
      setFullData(data);
    }
  }, [data, isLoading]);

  useEffect(() => {
    if (searchValue) {
      const result = searchTable(searchValue, data);
      setFullData(result);
    } else {
      setFullData(data);
    }
  }, [searchValue, data]);

  const handleSortTable = (column) => {
    if (sortedBy !== column || sortStatus === "") {
      setSortStatus("asc");
      setSortedBy(column);
      setFullData(sortTable(fullData, "asc", column));
    } else if (sortStatus === "asc") {
      setSortStatus("desc");
      setFullData(sortTable(fullData, "desc", column));
    } else {
      setSortStatus("");
      setFullData(data);
    }
  };

  return (
    <>
      <div className="d-flex align-items-center mb-4 flex-wrap">
        <h4 className="fs-20 font-w600 me-auto">Submissions</h4>
      </div>
      <div className="row">
        <div className="col-xl-13">
          <div className="table-responsive">
            <table className="submission-table table display mb-4 dataTablesCard job-table table-responsive-xl card-table dataTable no-footer">
              <thead>
                <tr style={{ textAlign: "center" }}>
                  <th>No</th>
                  <th>User ID</th>
                  <th>Quest Title</th>
                  <th>Status</th>
                  <th>File URL</th>
                  <th>Video URL</th>
                  <th
                    className="sortBy"
                    onClick={() => handleSortTable("submittedOn")}
                  >
                    Submission Date
                    {sortedBy === "submittedOn" && (
                      <Arrow direction={sortStatus} />
                    )}
                  </th>
                </tr>
              </thead>
              <tbody style={{ textAlign: "center" }}>
                {submissions.map((submission, index) => (
                  <tr key={index}>
                    <td>#{submission.id}</td>
                    <td>{submission.userId}</td>
                    <td>{submission.quest.title}</td>
                    <td>
                      <span
                        className={`badge badge-lg light badge-${
                          submission.status === "pending"
                            ? "warning"
                            : "success"
                        }`}
                      >
                        {submission.status}
                      </span>
                    </td>
                    <td>{submission.fileUrl}</td>
                    <td>{submission.videoUrl}</td>
                    <td>
                      {new Date(submission.submittedOn).toLocaleString("en-US", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </td>{" "}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* Start Pagination */}
        <PaginationFiltration
          data={fullData}
          setQuests={setSubmissions}
          sortStatus={sortStatus}
        />
      </div>
    </>
  );
};

export default SubmissionLists;
